<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('contact') }}
    </h1>
    <span v-if="country_name_fplus == 'greece' && gateway_code =='mobivas'">
     
        <contact-paydash-greek/>
      
       
     
    </span>
    <span v-else>
      <contact/>
    </span>
    
  </div>
</template>

<script>
import Contact from './../Contact';
import ContactGRPaydashGreek from './ContactGRPaydashGreek';
import ContactGRPaydashEnglish from './ContactGRPaydashEnglish';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_fplus", "country_fplus","country_name_fplus","gateway_code"]),
  components:{
    'contact': Contact,
    'contact-paydash-greek': ContactGRPaydashGreek,
    'contact-paydash-english': ContactGRPaydashEnglish

  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/funplus/Contact.vue